import { render, staticRenderFns } from "./DefenseProgram.vue?vue&type=template&id=6a4d2941&"
import script from "./DefenseProgram.vue?vue&type=script&lang=js&"
export * from "./DefenseProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports